<template>
  <v-row>
    <v-col class="pb-0">
      <h1 class="mb-6">Редактирование почты</h1>
      <v-row>
        <v-col cols="12" sm="6">
          <v-row>
            <v-col cols="10" sm="8" class="py-0">
              <v-text-field
                flat
                label="добавление нового e-mail"
                v-model='newMail'
                :rules="[
                  () => /.+@.+\..+/.test(newMail) || 'E-mail должен быть корректным',
                ]"
                prepend-inner-icon="mdi-at"
                solo
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-btn
                color="primary"
                class="text-none"
                dark
                @click="addMail()"
              >
                Добавить e-mail
              </v-btn>
            </v-col>
            <v-col cols="12" sm="8" class="py-0">
              <v-autocomplete
                label="Список e-mail для рассылок сообщения"
                :items="mails"
                v-model='isMail'
                prepend-inner-icon="mdi-email-remove-outline"
                item-text="mail"
                item-value="id"
                type="string"
                outlined
                dense
                flat
                clearable
              />
            </v-col>
            <v-col cols="3" class="py-0">
              <v-btn
                color="error"
                class="text-none"
                dark
                @click="removeMail"
              >
                Удалить e-mail
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pb-3 pt-0">
          <v-card>
            <v-data-table
              class="table"
              :headers="headers"
              :items="mails"
              hide-default-footer
            >
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EditMail',
  data () {
    return {
      dataMail: [],
      dialog: {},
      choiceMail: '',
      newMail: '',
      isMail: null,
      headers: [
        {
          text: 'id',
          value: 'id',
        },
        {
          text: 'e-mail',
          value: 'mail',
        },
      ],
    };
  },
  created () {
    this.getMail();
  },

  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
      mails: 'AdminSettings/mails',
    }),
  },
  methods: {
    ...mapActions({
      getDoorphone: 'Doorphone/getDoorphone',
      getTempCodeMail: 'AdminSettings/getTempCodeMail',
      addTempCodeMail: 'AdminSettings/addTempCodeMail',
      deleteTempCodeMail: 'AdminSettings/deleteTempCodeMail',
    }),
    getMail () {
      this.getTempCodeMail()
        .then((data) => {
          this.dataMail = data.data;
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Не удалось получить данные e-mail');
        });
    },
    addMail () {
      if (/.+@.+\..+/.test(this.newMail) && this.newMail) {
        this.addTempCodeMail({
          mail: this.newMail,
        })
          .then((data) => {
            this.$flash_success('Изменения успешно сохранены');
            this.getMail();
          })
          .catch((e) => {
            console.error(e);
            this.$flash_warning('Не удалось сохранить изменения');
          });
      } else {
        this.$flash_danger('E-mail должен быть корректным');
      }
    },
    removeMail () {
      if (this.isMail !== null) {
        this.deleteTempCodeMail(this.isMail)
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch((e) => {
            console.error(e);
            this.$flash_warning('Не удалось удалить e-mail');
          });
      } else {
        this.$flash_danger('Выберите e-mail');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
